import { render } from "./ModalHeader.vue?vue&type=template&id=f8b274ec&scoped=true&ts=true"
import script from "./ModalHeader.vue?vue&type=script&lang=ts"
export * from "./ModalHeader.vue?vue&type=script&lang=ts"

import "./ModalHeader.vue?vue&type=style&index=0&id=f8b274ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b274ec"]])

export default __exports__